import React from "react";

const ChapterFigure = props => {
  const title =
    props.title.length > 50 ? `${props.title.slice(0, 50)}...` : props.title;
  return (
    <li className="chapter-list-item">
      <button
        className="chapter-cover"
        onClick={props.onClick}
        style={{
          background: `linear-gradient(rgba(0,0,0, 0.6), rgba(0,0,0, 0.6)), url(${
            props.cover
          })`
        }}
      >
        <div className="title">{title}</div>
        <div className="count">{`${props.count} ${i18n.t(
          "reader.panels.figures"
        )}`}</div>
      </button>
    </li>
  );
};

export default ChapterFigure;
